<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[contractClasses$]"></ef-loading-container>
<ef-class-presenter
  [contractClasses] = 'contractClasses$ | async' 
  [contracts] = 'contracts$ | async'
  [process] = 'process$ | async'  
  (SaveContractClasses)="onSaveContractClasses($event)"
  (LoadContractClasses)="onLoadContractClasses($event)"
  [selectedError]="selectedErrorWithStatus$ | async"
  (ShowError)="this.ShowError.next($event)"
>
</ef-class-presenter>
